import { type DynamicOptions } from 'next/dynamic'

export interface TIdleOptions {
    enableIdleCallback?: boolean
    /**
   * requestIdleCallback 的超时时间（ms）
   * @default 500
   */
    idleCallbackTimeout?: number
    /**
     * setTimeout 的延迟时间（ms）
     * @default 2000
     */
    setTimeoutDelay?: number
}

export interface TObserverOptions {
    enableObserverVisible?: boolean
    rootMargin?: string
    wrapperElement?: 'div' | 'section'
    serverJsx?: React.ReactNode
    /**
     * 是否启用 IntersectionObserver 优化
     * @default true
     */
}

export const LAZY_HYDRATE_MARKER = Symbol.for("lazyHydrate.Hydration");

export interface THydrateOptions {
    displayImmediatelyOnPC?: boolean
    observerOptions?: TObserverOptions
    idleOptions?: TIdleOptions
    /**
     * 如果 loading 为函数，是否直接返回 loading 函数
     * @default false
     */
    returnLoadingFunction?: boolean
}

export type ComponentProps = {
    [key: string]: unknown
    wrapperProps?: Record<string, any>
    forceHydrate?: boolean
}

export type LazyHydrateOptions<P> = Omit<DynamicOptions<P>, 'loader'> & THydrateOptions

export type AnyFunction = () => void
